import React from 'react'
import PropTypes from 'prop-types'

const BODY_CLASS = 'tw:flex-1 tw:overflow-y-auto tw:p-6 tw:flex tw:flex-col tw:gap-6'

const DrawerBody = ({ children, className }) => 
  <div className={`${BODY_CLASS} ${className}`}>{children}</div>


DrawerBody.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

DrawerBody.defaultProps = { className: '' }

export default DrawerBody
